export default "/images/Opportunity2.png?0ebf7509fecda1477d80988774f81265";